import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DTypeFormTimeField } from '@grupo-constant/next-dtype/form';
import { TimeFormatStyle, Timepicker, TimeStepField } from '@grupo-constant/next-dtype/types';
import { NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { NgbTimeStringAdapter } from './time-string-adapter';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { TimepickerAutofillComponent } from '../../../components/timepicker-autofill/timepicker-autofill.component';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';

@Component({
    selector: 'timepicker-field-component',
    templateUrl: './timepicker-field.component.html',
    imports: [CommonModule, MatButtonModule, MatIconModule, TimepickerAutofillComponent,
        LocalizePipe, TranslocoModule],
    providers: [{ provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class DtypeTimepickerFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormTimeField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    min: string;
    max: string;
    style: TimeFormatStyle;
    step: number;
    allowManual: boolean;

    hourStep = 1;
    minuteStep = 1;
    secondStep = 1;

    constructor() { }

    ngOnInit() {
        const dTypeCol = this.field.dTypeCol as Timepicker;

        if (dTypeCol.min) {
            this.min = dTypeCol.min;
        }
        if (dTypeCol.max) {
            this.max = dTypeCol.max;
        }

        this.style = dTypeCol.style;

        const stepOver = dTypeCol.stepOver;
        const step = dTypeCol.step;
        if (stepOver) {
            switch (stepOver) { // Las magnitudes menores se ponen a 0 para que no se puedan mover, las mayores se quedan por defecto a 1
                case TimeStepField.HOUR:
                    this.hourStep = step;
                    this.minuteStep = 0;
                    this.secondStep = 0;
                    break;
                case TimeStepField.MINUTE:
                    this.hourStep = 1;
                    this.minuteStep = step;
                    this.secondStep = 0;
                    break;
                case TimeStepField.SECOND:
                    this.hourStep = 1;
                    this.minuteStep = 1;
                    this.secondStep = step;
                    break;
                default:
                    this.hourStep = 1;
                    this.minuteStep = 1;
                    this.secondStep = 1;
                    break;
            }
        }

        this.allowManual = dTypeCol.allowManual;

        const readonlyOnUpdate = dTypeCol.readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    clear() {
        this.field.control.setValue(undefined);
    }

}
